import { render, staticRenderFns } from "./TrademarkOppositionBasisForOppositionList.vue?vue&type=template&id=82053fdc&"
import script from "./TrademarkOppositionBasisForOppositionList.vue?vue&type=script&lang=js&"
export * from "./TrademarkOppositionBasisForOppositionList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkOppositionBasisForOppositionList.vue?vue&type=style&index=0&id=82053fdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports